import React, { createContext, useContext, useState } from 'react';
import { normalizeRole } from '../lib/roles';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [auth, setAuth] = useState(() => {
    try {
      const token = localStorage.getItem('token');
      const role = normalizeRole(localStorage.getItem('role'));
      const user = JSON.parse(localStorage.getItem('user') || 'null');
      if (token) return { token, role, user };
    } catch {}
    return null;
  });

  // Email+parol ham, telefon OTP ham shu yagona joydan o'tadi (token + role + user → localStorage).
  const login = (token, rawRole, user) => {
    const role = normalizeRole(rawRole);
    localStorage.setItem('token', token);
    localStorage.setItem('role', role);
    localStorage.setItem('user', JSON.stringify(user));
    setAuth({ token, role, user });
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('user');
    setAuth(null);
  };

  return (
    <AuthContext.Provider value={{ auth, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
